import React from "react";
import Box from "@mui/material/Box";

export default function BaseCard({
  children, // children to be rendered in the modal
}) {

  return (
    <>
        <Box
            sx={{
                display: "flex",
                justifyContent: "center", // Centers horizontally
                alignItems: "center", // Centers vertically
            }}
        >
            <Box
                sx={{
                    backgroundColor: "#ffffff",
                    border: "none",
                    padding: "20px",
                    borderRadius: "8px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    maxHeight: "650px",
                    height: "auto",            
                    display: "inline-block",
                    verticalAlign: "top",
                    marginRight: "20px",
                    boxSizing: "border-box",
                    width: "40%",
                    marginTop: "20px"
                }}
            >
                <Box
                    sx={{
                        marginTop: "20px",
                        alignItems: "center",
                    }}
                >
                    {children}
                </Box>
            </Box>
        </Box>
    </>
  );
}
